// CUSTOM:START Wistia 8x8.js
window.__8x8Chat = window.__8x8Chat || {};
window.__8x8Chat = {
  uuid: 'script_3833744285e9749948dc975.24705190',
  tenant: 'c3lsdmFuZTAx',  
  channel: 'Sylvane Chat',
  domain: 'https://vcc-na7.8x8.com',
  path: '/.',
  buttonContainerId: '__8x8-chat-button-container-script_3833744285e9749948dc975.24705190',
  align: 'right'
};

(function() {
  var se = document.createElement("script");
  se.type = "text/javascript";
  se.async = true;
  se.src = window.__8x8Chat.domain + window.__8x8Chat.path + '/CHAT/common/js/chat.js';

  var os = document.getElementsByTagName("script")[0];
  os.parentNode.insertBefore(se, os);

  setTimeout(() =>
  {
    var triggers = document.querySelectorAll('._8x8chat');
    triggers.forEach((trigger) => {
      var link = trigger.querySelector('a');
      if(link.getAttribute('data-type') !== 'online') {
        link.querySelector('img').setAttribute('alt','Live Chat is Offline');
      } else {
        link.querySelector('img').setAttribute('alt','Live Chat is Online');
      }
    });

    var inline_triggers = document.querySelectorAll('a[href="#8x8chat"]');
    inline_triggers.forEach((inline_trigger) => {
      inline_trigger.addEventListener('click', function() {
        document.querySelector('._8x8chat a').click();
      });
    });
  }, 6000);
  
})();
// CUSTOM:END Wistia 8x8.js
